import {useQuery} from '@tanstack/react-query';
import axios from 'axios';

const useCategoriesWithActions = () => {
  const {data, isLoading, error, refetch} = useQuery({
    queryKey: ['categories'],
    queryFn: async () => await axios.get('/api/categories-and-actions').then((res) => res.data),
    staleTime: Infinity,
  });

  return {data, isLoading, error, refetch};
};

export default useCategoriesWithActions;
